module.exports = __webpack_public_path__ + "static/media/youtube.855f6da0.png";